import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPlayStoreComponent } from './app-play-store.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AppPlayStoreComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    AppPlayStoreComponent
  ],
})
export class AppPlayStoreModule { }
